<template>
  <div>
    <el-dialog :title="$t('tips')" :visible.sync="dialogVisible" width="30%" top="15%" :before-close="closeDia">
      <div class="tip-style">
        <p>{{ tipsText }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleCloseAd">{{ $t('cancel') }}</el-button> -->
        <el-button size="mini" type="primary" class="confirm-btn-plain" @click="closeDia">{{ buttonText }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'heartBeat',
  props: {
    showFooter: {
      type: Boolean,
    },
  },
  computed: {
    dynamicData() {
      return this.$store.getters.dynamicGT6Data
    },
  },
  data() {
    return {
      dialogVisible: false,
      tipsText: this.$i18.language('由于在【E平台】上处于不活动状态，您将会被登出。 请点击继续以保持页面的活动状态。'),
      buttonText: this.$i18.language('继续'),
      timer: null, //定时器名称
      resCode: null,
      tokenNewL: null,
      
    }
  },
  mounted() {
    this.setTime()
    this.dealStorage = (e) => {
      let path = location.href
      if(path.indexOf("login")<0) {
        if (e.key == 'accessToken' || e.key == 'gt6_dynamic'){//判断是否是目标值发生改变，除当前窗口外其他窗门刷新使用localstorage里面的最新token
          if(e.key == 'accessToken' && (localStorage.getItem('gt6_dynamic') || e.url.indexOf("sou")>0 || e.url.indexOf("crm")>0 || e.url.indexOf("/m?")>0)) {
            window.location.reload()
          } else if(e.key == 'gt6_dynamic') {
            // 解决浏览器刷新时菜单还没加载进来，使用延时处理
            window.location.reload()
          }
        }
      }
    }
    window.addEventListener('storage', this.dealStorage)
  },
  methods: {
    setTime() {
      //每隔5分钟运行一次保存方法
      // console.log(this.showFooter)
      if (this.showFooter) {
        this.timer = setInterval(() => {
          this.getLoginStatus()
        }, 1000 * 60*5 )
      }
    },
    getLoginStatus() {
      this.$api.public.getLoginStatus({ token: localStorage.getItem('accessToken') }).then((res) => {
        this.resCode = res.code
        if (this.resCode == 200) {
          this.dialogVisible = true
          this.$emit("inactive", false)
          localStorage.setItem('tokenActive', 0)
          //清除当前的定时器
          //  clearInterval(this.timer) // 清除定时器
          //  this.timer = null
        } else if (this.resCode == 400) {
          this.dialogVisible = true
          this.$emit("inactive", false)
          localStorage.setItem('tokenActive', 0)
          this.tipsText = this.$i18.language('由于在【E平台】上处于不活动状态，您已经被登出。')
          this.buttonText = this.$i18.language('重新登陆')
        } else {
          localStorage.setItem('tokenActive', 1)
        }
      })
    },
    closeDia() {
      if (this.resCode == 200) {
        //从新获取token 然后赋值 新的  token
        this.getNewToken()
      } else if (this.resCode == 400) {
        this.$api.user.loginout({ token:localStorage.getItem('accessToken') }).then((res) => {})
        window.localStorage.clear()
        window.sessionStorage.clear()
        this.$store.commit('set_token', null)
        window.location.href = this.$util.getLoginUrl()
      }
      this.$emit("inactive", true)
      this.dialogVisible = false
    },
    //从新获取token
    getNewToken() {
      let params = {
        token: localStorage.getItem('accessToken'),
        product: 'gt6',
      }
      this.$api.public.relogin(params).then((res) => {
        if (res && res.code == 200) {
          this.tokenNewL=res.data.accessToken;
          this.$emit("inactive", true)
          localStorage.setItem('tokenActive', 1)
          localStorage.setItem('accessToken', res.data.accessToken)
          this.$store.commit('set_token', res.data.accessToken)
          // 重置易学课链接
          this.handleSetExuekerLink()
          //放开定时器
          // this.setTime()
        }
      })
    },
    // 易学课链接
    handleSetExuekerLink() {
      let user = localStorage.getItem('set_account_info') ? JSON.parse(localStorage.getItem('set_account_info')) : null
      if(user) {
        let pro = user.products.find(item=>item.key == 'exueker2')
        const url = new URL(pro.url);
        let token = localStorage.getItem("accessToken")
        url.searchParams.set('token', token);
        pro.url = url.toString();
        localStorage.setItem("set_account_info", JSON.stringify(user))
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer) // 清除定时器
    this.timer = null
  },
}
</script>

<style lang="scss" scoped>
.tip-style p {
  line-height: 23px;
}
</style>